import { render, staticRenderFns } from "./CustomerAnalytics.vue?vue&type=template&id=7b2fd225&scoped=true&"
import script from "./CustomerAnalytics.vue?vue&type=script&lang=js&"
export * from "./CustomerAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAnalytics.vue?vue&type=style&index=0&id=7b2fd225&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2fd225",
  null
  
)

export default component.exports